import "ace-builds/src-noconflict/mode-html";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Form, Grid, GridColumn } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";
import "modules/FactoryExportsDashboard/components/ExportModal/components/EmailMessageEditor/EmailMessageEditor.scss";
import { DEFAULT_EMAIL_MESSAGE, DEFAULT_EMAIL_SUBJECT } from "modules/FactoryExportsDashboard/utils";

import type { FactoryExportFormPayload } from "modules/FactoryExportsDashboard/components/ExportModal/hooks";

const FormHelper = createFormHelper<FactoryExportFormPayload>();

export const EmailMessageEditor = () => {
  const { t } = useTranslation();

  const [showDesign, setShowDesign] = useState(false);

  const iframeRef = useRef<HTMLIFrameElement>(null);
  const { setValue } = FormHelper.useFormContext();
  const emailMessage = FormHelper.useWatch("email_message");

  const handleToggleShowDesign = () => setShowDesign(!showDesign);

  const handleRevertToDefault = () => {
    setValue("email_subject", DEFAULT_EMAIL_SUBJECT);
    setValue("email_message", DEFAULT_EMAIL_MESSAGE);
  };

  const handleIframeLoad = () => {
    const iframe = iframeRef.current;
    if (!iframe?.contentWindow) return;

    iframe.style.height = `${iframe.contentWindow.document.body.scrollHeight + 10}px`;
  };

  return (
    <Grid columns="equal" className="EmailMessageEditor">
      <GridColumn>
        <div className="toolbar">
          <label>{t("v8_email_message", "Email message")}</label>

          <div className="toolbar-buttons">
            <Button type="button" className="blue" onClick={handleToggleShowDesign}>
              {showDesign ? t("v8_show_editor", "Show editor") : t("v8_show_design", "Show design")}
            </Button>
            <Button type="button" className="orange" onClick={handleRevertToDefault}>
              {t("v8_revert_to_default", "Revert to default")}
            </Button>
          </div>
        </div>

        {showDesign ? (
          <iframe ref={iframeRef} className="preview" width="100%" scrolling="no" sandbox="allow-same-origin" srcDoc={emailMessage} onLoad={handleIframeLoad} />
        ) : (
          <Form.Field>
            <FormHelper.Field.TextEditor
              name="email_message"
              editorProps={{
                mode: "html",
                theme: "monokai",
                width: "100%",
                fontSize: 14,
                showPrintMargin: false,
                showGutter: true,
                name: "factory-export-email-message",
                placeholder: t("v8_email_message", "Email message"),
                setOptions: {
                  enableBasicAutocompletion: false,
                  enableLiveAutocompletion: false,
                  enableSnippets: false,
                  showLineNumbers: true,
                  tabSize: 2
                }
              }}
            />
          </Form.Field>
        )}
      </GridColumn>
    </Grid>
  );
};
